import EditableTextBlock from "../../utils/editable-text-block";

export const VideoGreetingsCardBlock = () => {
    return <section className="section s-vcard">
	<div className="inside-wrapper">

		<h2 className="section__title">
		Welcome to Slidy!
		</h2>

		<div className="s-vcard__holder">

			{/*<picture className="s-vcard__pic">
				<source type="image/webp" srcSet="./img/vcard.webp 1x, ./img/vcard@2x.webp 2x" />
				<img className="s-vcard__img" src="./img/vcard.png" srcSet="./img/vcard@2x.png 2x" alt="Video greetings card" loading="lazy" width="585" height="260" />
			</picture>*/}
			<iframe width="560" height="315" src="https://www.youtube.com/embed/nS7TdRkgokY?si=Y1E6ZXbB9opzGY8-&controls=0" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowFullScreen />

			<div className="s-vcard__text">

				<p>
					<EditableTextBlock definedName="video-greetings-card-text" title="Video greetings card text">
					{`The Video Greeting Card offers a&nbsp;unique platform to&nbsp;turn your cherished memories into a&nbsp;dynamic and personalized gift. Whether it&rsquo;s a&nbsp;wedding, birthday, anniversary, or&nbsp;any other special occasion, this greeting card allows you to&nbsp;share your heartfelt messages and moments in&nbsp;a&nbsp;way that truly resonates.`}
					</EditableTextBlock>
				</p>
				{/*
				<p>
					<a href="#" className="btn btn_cta">Get more details</a>
				</p>
				*/}
			</div>

		</div>


	</div>
</section>
}

export default VideoGreetingsCardBlock;